const DEFAULT_EXT_SRC_LOAD_TIMEOUT_MS = 10 * 1000; // 10 seconds

export { DEFAULT_EXT_SRC_LOAD_TIMEOUT_MS };
